import React from 'react'

function Reviews() {
  return (
    <div className='About_US_SULUHU'>

               <p className='About_us_p'>Reviews</p>

        <p className='About_us_SUB'>Average Rating: ⭐⭐⭐⭐⭐ (4.8/5)</p>
        <div className='about_us_description'>
        •	John M., University of Nairobi – "Suluhu made my campus move-in stress-free! The starter pack had everything I needed."
        •	Aisha K., Kenyatta University – "I love the convenience! Ordered my bed and mattress, and it was delivered within a day!"
        •	Kevin O., Moi University – "Affordable and great quality. The kitchen set was a lifesaver!"
        </div>

  
      
    </div>
  )
}

export default Reviews
